import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";
import speakersData from "../constants/SpeakersData";

export const Team = () => {
  const { t } = useTranslation();

  const keynotes = speakersData.filter((s) => s.keynote);
  const regulars = speakersData.filter((s) => !s.keynote);
  const hasSpeakers = speakersData.length > 0;

  const SpeakerCard = ({ speaker, isKeynote }) => (
    <div style={{
      background: "white",
      borderRadius: "15px",
      padding: isKeynote ? "2rem" : "1.5rem",
      boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
      textAlign: "center",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      transition: "all 0.3s ease",
    }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.08)";
      }}
    >
      <div style={{
        width: isKeynote ? "150px" : "120px",
        height: isKeynote ? "150px" : "120px",
        borderRadius: "50%",
        overflow: "hidden",
        marginBottom: "1rem",
        border: isKeynote ? "4px solid #764ba2" : "3px solid #667eea",
        boxShadow: isKeynote ? "0 4px 15px rgba(118, 75, 162, 0.3)" : "0 3px 10px rgba(102, 126, 234, 0.2)",
      }}>
        <img
          src={speaker.photo}
          alt={speaker.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          loading="lazy"
        />
      </div>
      <h5 style={{ color: "#333", fontWeight: "bold", marginBottom: "0.3rem", fontSize: isKeynote ? "1.15rem" : "1rem" }}>
        {speaker.name}
      </h5>
      <p style={{ color: "#667eea", fontWeight: "600", fontSize: "0.85rem", marginBottom: "0.2rem" }}>
        {speaker.position}
      </p>
      <p style={{ color: "#888", fontSize: "0.85rem", marginBottom: "0.8rem", flex: 1 }}>
        {speaker.institution}
      </p>
      {speaker.linkedinUrl && (
        <a
          href={speaker.linkedinUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.3rem",
            color: "#0077b5",
            fontSize: "0.85rem",
            fontWeight: "500",
            textDecoration: "none",
            transition: "opacity 0.3s ease",
          }}
          onMouseOver={(e) => { e.currentTarget.style.opacity = "0.7"; }}
          onMouseOut={(e) => { e.currentTarget.style.opacity = "1"; }}
        >
          LinkedIn ↗
        </a>
      )}
      {isKeynote && (
        <span style={{
          display: "inline-block",
          marginTop: "0.8rem",
          padding: "0.3rem 1rem",
          borderRadius: "20px",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          fontSize: "0.75rem",
          fontWeight: "600",
          letterSpacing: "0.5px",
        }}>
          KEYNOTE SPEAKER
        </span>
      )}
    </div>
  );

  return (
    <div style={{ paddingTop: "60px", paddingBottom: "60px", backgroundColor: "#f8f9fa" }}>
      <Container>
        {/* Título */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ color: "#333333", fontWeight: "bold", marginBottom: "1rem" }}>
              {t("speakers_title")}
            </h1>
            <p className="text-center lead" style={{ color: "#666666" }}>
              {t("speakers_lead")}
            </p>
          </Col>
        </Row>

        {hasSpeakers ? (
          <>
            {/* Keynote Speakers */}
            {keynotes.length > 0 && (
              <>
                <Row className="mb-4">
                  <Col>
                    <h2 className="text-center" style={{ color: "#333", fontWeight: "600" }}>
                      Keynote Speakers
                    </h2>
                  </Col>
                </Row>
                <Row className="justify-content-center mb-5">
                  {keynotes.map((speaker, idx) => (
                    <Col md="6" lg="4" key={idx} className="mb-4">
                      <SpeakerCard speaker={speaker} isKeynote={true} />
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {/* Regular Speakers */}
            {regulars.length > 0 && (
              <>
                {keynotes.length > 0 && (
                  <Row className="mb-4">
                    <Col>
                      <h2 className="text-center" style={{ color: "#333", fontWeight: "600" }}>
                        {t("speakers_confirmed")}
                      </h2>
                    </Col>
                  </Row>
                )}
                <Row className="justify-content-center">
                  {regulars.map((speaker, idx) => (
                    <Col sm="6" md="4" lg="3" key={idx} className="mb-4">
                      <SpeakerCard speaker={speaker} isKeynote={false} />
                    </Col>
                  ))}
                </Row>
              </>
            )}
          </>
        ) : (
          /* Placeholder cuando no hay speakers */
          <Row className="mb-5">
            <Col md={{ size: 8, offset: 2 }}>
              <div className="text-center p-5" style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "15px",
                color: "white",
                boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
              }}>
                <span style={{ fontSize: "3rem" }}>🎤</span>
                <h3 style={{ fontWeight: "bold", color: "white", marginTop: "1rem" }}>
                  {t("speakers_coming_soon")}
                </h3>
                <p style={{ color: "rgba(255,255,255,0.9)", fontSize: "1.1rem", whiteSpace: "pre-line" }}>
                  {t("speakers_coming_soon_text")}
                </p>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};